import { useCallback, useEffect } from "react";
import ImpoundActivitiesService from "../../../../../../../../../../../services/accounts/impounds/activities";
import { FormInstance } from "antd";
import dayjs from "dayjs";
import { transformToFormatted } from "../../../../../../../../../../../lib/transformToFloat";
import { usePermissions } from "../../../../../../../../../../../lib/hooks/usePermissions";

export const useFetch = (
  id: string | null,
  form: FormInstance,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { hasAccessByController } = usePermissions("ImpoundActivities");

  const fetchData = useCallback(async () => {
    if (id) {
      try {
        const response = await ImpoundActivitiesService.fetch(id);

        const { date, amount, balance } = response;

        response.date = dayjs(date);

        response.amount = transformToFormatted(amount);
        response.balance = transformToFormatted(balance);

        form.setFieldsValue(response);

        hasAccessByController("Modify") && setIsLoading(false);
      } catch {
        hasAccessByController("Modify") && setIsLoading(false);
      }
    }
  }, [id, form, setIsLoading, hasAccessByController]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
};
